import {
  REQUEST_CAMPAIGN_PAYMENT_LIST
} from './mutation-types'

import axiosInst from '@/utility/axiosInst'

export default {
  requestCampaignPaymentList({commit}, payload) {
    const {currentPage, searchType, searchWord} = payload
    return axiosInst.springAxiosInst.get("/admin/payment/campaign-payment-list", {
      params: {
          page: currentPage,
          searchType: searchType,
          searchWord : searchWord
        }
      }).then((res) => {
        commit(REQUEST_CAMPAIGN_PAYMENT_LIST, res.data)
      })
  }
}